<template>
  <v-flex 
    fill-height 
    lg12 
    md12>
    <v-card class="fill-height">
      <v-layout 
        column 
        fill-height>
        <v-toolbar 
          flat 
          color="secondary" 
          dense>
          <v-toolbar-title class="primarytext--text">Le mie note</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>

        <v-layout 
          row 
          wrap 
          align-center 
          justify-space-around>
          <v-flex 
            align-self-start 
            shrink 
            pt-3>
            <v-date-picker
              v-model="date"
              :events="daModificare"
              :allowed-dates="allowedMonths"
              :max="$moment().format('YYYY-MM')"
              event-color="error"
              type="month"
              color="secondary lighten-1"
              locale="it-IT"
              class="elevation-0"
              @input="getNote"
            />
          </v-flex>
          <v-flex 
            v-if="!!date" 
            xs12 
            sm12 
            md12 
            lg8 
            align-self-start>              
            <v-toolbar 
              flat 
              color="transparent">
              <v-switch 
                v-model="switchA" 
                label="Mostrare solo non lavorare o da modificare" 
                hide-details 
                color="tree" 
                class="my-3"/>
              <v-spacer/>
              <v-btn 
                v-if="!meseChiuso" 
                color="#48586e" 
                class="primary--text" 
                @click="chiudiMeseClickHandler">
                <v-icon 
                  small 
                  left 
                  color="primary">fas fa-lock</v-icon>Chiudere mese
              </v-btn>
              <!--                <v-btn color="#48586e" @click="modalFirmAll = true" class="primary--text" :disabled="loading || modalFirmAll">
                    <v-icon small left color="primary">fas fa-paper-plane</v-icon>Firma tutte
                </v-btn>-->
            </v-toolbar>
            <v-container 
              fluid 
              grid-list-md 
              class="scroll-y">
              <div 
                v-if="pages > 1" 
                class="text-xs-center pt-2">
                <v-pagination 
                  v-model="pagination.page" 
                  :length="pages" 
                  color="secondary"/>
              </div>
              <v-data-iterator
                :items="items"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                hide-actions
                content-tag="v-layout"
                row
                wrap
              >
                <v-flex
                  slot="no-data"
                  align-self-center
                  class="title font-weight-light grey--text pa-3 text-xs-center"
                >Nessuna spesa nella data selezionata!</v-flex>
                <v-flex 
                  slot="item" 
                  slot-scope="props" 
                  xs12 
                  sm6 
                  md4 
                  lg4>
                  <v-card>
                    <v-card-title>
                      <span><h4>{{ $moment(props.item.data).format('D MMMM YYYY, dddd') }}</h4></span>
                    </v-card-title>
                    <v-divider/>
                    <v-list dense>
                      <template v-for="(i, ind) in props.item.items">
                        <CardNota 
                          :key="ind"
                          :item="i" 
                          :mese="mese"/>
                      </template>
                      <v-divider/>
                      <v-list-tile>
                        <v-list-tile-content>
                          <span style="font-weight:bold">Totale</span>
                        </v-list-tile-content>
                        <v-list-tile-content
                          class="align-end"
                          style="font-weight:bold"
                        >{{ totale(props.item.items) }}€</v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>
                          <span style="font-weight:bold">Totale Anticipato *</span>
                        </v-list-tile-content>
                        <v-list-tile-content
                          class="align-end"
                          style="font-weight:bold"
                        >{{ totaleAnticipato(props.item.items) }}€</v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>
                          <span style="font-weight:bold">Totale Confermato</span>
                        </v-list-tile-content>
                        <v-list-tile-content
                          class="align-end"
                          style="font-weight:bold"
                        >{{ totaleBonifico(props.item.items) }}€</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>
              </v-data-iterator>
              <div 
                v-if="pages > 1" 
                class="text-xs-center pt-2">
                <v-pagination 
                  v-model="pagination.page" 
                  :length="pages" 
                  color="secondary"/>
              </div>
            </v-container>
          </v-flex>
          <v-flex
            v-else
            xs12
            sm8
            md8
            lg8
            align-self-center
            class="title font-weight-light grey--text pa-3 text-xs-center"
          >Seleziona il mese delle spese!</v-flex>
        </v-layout>
      </v-layout>
    </v-card>      
      
    <!--    <ModalFirmaTutteRichieste 
        @on-close="modalFirmAll = false"
        @on-confirm="firmaTutteRichieste"
        :items="richiesteSenzaFirma"
        :dialog="modalFirmAll"></ModalFirmaTutteRichieste>-->
  </v-flex>
</template>

<script>
import 'vue-swipe-actions/dist/vue-swipe-actions.css';
import { mapActions } from "vuex";
import CardNota from "./CardNota.vue";
//import ModalFirmaTutteRichieste from "./ModalFirmaTutteRichieste.vue";

export default {
  name: "AccDettaglioNote",
  components: {
    CardNota,
//    ModalFirmaTutteRichieste
  },
  props: {},
  data: () => ({
    loader: false,
    date: null,
    rowsPerPageItems: [3, 8, 12],
    pagination: {
      rowsPerPage: 3
    },
    codice: null,
    mese: "",
    switchA: false,
    modalFirmAll: false
  }),
  computed: {
    items() {
      return this.switchA 
            ? this.$store.getters["notaSpese/noteNonLavorate"] 
            : this.$store.getters["notaSpese/noteGroupByDate"];
    },
    daModificare() {
      return this.$store.getters["notaSpese/daModificare"];
    },
    noteNonFirmate() {
      return this.$store.getters["notaSpese/note"].filter(n => n.data_firma === null);
    },
    richiesteSenzaFirma() {
      return Array.from(new Set(this.noteNonFirmate.map(item => item.codice)))
              .map(cod => {
                  let note = this.noteNonFirmate.filter(s => s.codice === cod)
                  return {
                      id: cod,
                      date: this.noteNonFirmate.find(s => s.codice === cod).data,
                      importoTotale: note.map(n => (+n.importo||0)).reduce((a, b) => a + b)
                  }
              })
    },
    loading() {
      return this.$store.getters["notaSpese/loading"];
    },
    pages() {
      return Math.ceil(this.items.length / this.pagination.rowsPerPage);
    },
    meseChiuso () {
      return this.$store.state.pageData.mesiChiusi.includes(this.date)
    }
  },
  created() {
      this.$store.dispatch("notaSpese/getAllNoteDaModifica");
  },
  methods: {
    ...mapActions("notaSpese", ["chiudiMeseSpesa"]),
    allowedMonths: val => val,
    getNote: function(e) {
      this.$data.mese = e;
      this.$store
        .dispatch("notaSpese/getNote", { data: e })
        .then(() => {});
    },
    totale(item) {
      var totale = 0;
      item.forEach(function(val) {
        totale += val.note
          .map(function(v) {
            return v.importo;
          })
          .reduce(function(a, b) {
            return +a + +b;
          }, 0);
      });
      return Number((totale).toFixed(2));
    },
    totaleAnticipato(item) {
      var totale = 0;
      item.forEach(function(val) {
        totale += val.note
          .filter(function(f) {
            return f.is_anticipata_azienda == 1;
          })
          .map(function(v) {
            return v.importo;
          })
          .reduce(function(a, b) {
            return +a + +b;
          }, 0);
      });
      return Number((totale).toFixed(2));
    },
    totaleBonifico(item) {
      var totale = 0;
      
      item.forEach(function(val) {
        totale += val.note
          .filter(function (v) {
              return v.stato == 1 && v.is_anticipata_azienda == 0
            })
          .map(function(v) {
            return v.importo;
          })
          .reduce(function(a, b) {
            return +a + +b;
          }, 0);
      });
      return Number((totale).toFixed(2));
    },
    firmaNota(codice, id_richiesta) {
      this.$store
        .dispatch("notaSpese/firmaNota", {
          codice: codice,
          id_richiesta: id_richiesta.cod,
          mese: this.$data.mese
        })
    },
    // firmaTutteRichieste(codice, selected) {
//        this.modalFirmAll = true
    // },
    chiudiMeseClickHandler() {
      this.chiudiMeseSpesa(this.date)
    }
  }
};
</script>

<style lang="scss">
.card-nota-item__wrap {
   .v-list__tile {
    min-height: 40px !important;
    height: auto !important;
    .auto-desc {      
      display: flex;
      flex-wrap: wrap;
      font-size: 11px;
      flex-direction: column;
      padding: 6px;
      align-items: center;
      width: 100%;
      .tratta-desc {
        font-size: 9px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/TabDettaglioNote.vue